import { emitterCreateDispatcher } from '@THC/utils/emitter';

import { useDerivedActionStateEmitter } from './useDerivedActionStateEmitter';

const dispatchEvent = emitterCreateDispatcher(useDerivedActionStateEmitter);

export const dispatchUseDerivedActionStateDisable = dispatchEvent('disable');
export const dispatchUseDerivedActionStateEnable = dispatchEvent('enable');
export const dispatchUseDerivedActionStateSet = dispatchEvent('set');
